import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"#000000a6","font-size":"12px","margin-bottom":"16px"} }, " 初始文件密码为 123456。如更新密码，请重新导出文件并用新密码打开 ", -1)
const _hoisted_2 = { style: {"text-align":"center"} }

import { ref, toRefs, reactive, onMounted } from "vue";
import type { Rule } from "ant-design-vue/es/form";
import moment from "moment";
import { useRoute } from "vue-router";
import { FormInstance, message } from "ant-design-vue";
import { changePassword, getUserInfo } from "@/api/login";

interface FormData {
  newPassword: string;
  confirmPassword: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UpdatePasswordModal',
  setup(__props, { expose: __expose }) {

const open = ref<boolean>(false);
const formRef = ref<FormInstance>();
const formdata = reactive<FormData>({
  newPassword: "",
  confirmPassword: "",
});
const rules: Record<string, Rule[]> = {
  endTime: [{ required: true, message: "请选择减保日期" }],
};
const isDefaultPassword = ref(true);
const showModal = () => {
  open.value = true;
  getUserInfoDetail();
};
const getUserInfoDetail = async () => {
  let res: any = await getUserInfo({});
  if (res.code == 200) {
    if (res.data.lastOfpChangeTime != null) {
      isDefaultPassword.value = false;
    }
  }
};
const handleSubmit = (values: any) => {
  try {
    if (values.confirmPassword != values.newPassword) {
      throw new Error("请确保两次密码一致");
    }
    let params = {
      newPassword: values.newPassword,
      type: "DOWNLOAD_FILE",
    };
    changePassword(params)
      .then((res: any) => {
        if (res.code == 200) {
          message.success("修改成功");
          open.value = false;
        } else {
          message.error(res.msg);
        }
      })
      .catch(() => {});
  } catch (error: any) {
    message.error(error.message);
  }
};
const handleFinishFailed = (errors: any) => {
  console.log(
    "%c [ errors ]-188",
    "font-size:13px; background:pink; color:#bf2c9f;",
    errors
  );
};
__expose({
  showModal,
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      open: open.value,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event)),
      title: "重置下载密码",
      width: "600px",
      okText: "确定",
      cancelText: "取消",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, _mergeProps({
          ref_key: "formRef",
          ref: formRef,
          model: formdata,
          style: {"width":"400px","margin":"0 auto"}
        }, {
          labelCol: { span: 5 },
          wrapperCol: { span: 16 },
        }, {
          rules: rules,
          onFinish: handleSubmit,
          onFinishFailed: handleFinishFailed
        }), {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              name: "newPassword",
              label: "新密码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formdata.newPassword,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formdata.newPassword) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "confirmPassword",
              label: "确认新密码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formdata.confirmPassword,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formdata.confirmPassword) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("提交修改")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 16, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})